// material
// components
import Page from '../components/configs/Page';

import {
  Stack,
  Container,
  Typography
} from '@mui/material';
// ----------------------------------------------------------------------

export default function PerfilPessoal() {
  return (
    <Page title="INPACT | Perfil">
      <Container maxWidth="xl">
            <Stack direction="row" alignItems="center" justifyContent="space-between" mb={2}>
                <Typography variant="h3" gutterBottom>
                    O Meu Perfil
                </Typography>
            </Stack>
        </Container>
    </Page>
  );
}
